<template>
    <v-tab-item>
        <div class="mb-5 transparent" v-for="(result, idx) in results" :key="idx">
            <div class="my-2">
                <span class="text-body-1 font-weight-bold">{{idx + 1}}. {{ categoryName(idx) }}</span>
            </div>
            <category-accordion
                v-if="result.length > 0"
                :calculationIdx="calculationIdx"
                :treatmentIdx="treatmentIdx"
                :drugIdx="idx"
                :products="result"
                :cultures="cultures"
                :categories="categories"
                :attributes="attributes"
                @send-to-tab-result="calculateTabResult($event, idx)"
            ></category-accordion>
            <v-card v-else class="px-10 py-10 " outlined>
                <v-row justify="center">
                    <v-col cols="12" class="d-flex justify-center">
                        <span class="text-body-2 text-md-h6">{{ $t('noData') }}</span>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="4" class="d-flex justify-center">
                        <v-btn
                            class="main--yellow"
                            depressed
                            @click="addSomePercents(0.1, idx)"
                        >
                            <span class="text-body-1 white--text">+10%</span>
                        </v-btn>
                    </v-col>
                    <v-col cols="4" class="d-flex justify-center">
                        <v-btn
                            class="main--yellow"
                            depressed
                            @click="addSomePercents(0.2, idx)"
                        >
                            <span class="text-body-1 white--text">+20%</span>
                        </v-btn>
                    </v-col>
                    <v-col cols="4" class="d-flex justify-center">
                        <v-btn
                            class="main--yellow"
                            depressed
                            @click="addSomePercents(0.3, idx)"
                        >
                            <span class="text-body-1 white--text">+30%</span>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </div>
        <v-divider></v-divider>
        <div class="px-2 py-4" v-if="this.tabCheckedDrugs.length > 0">
            <span class="d-block text-body-2 font-weight-bold">{{ $t('targetBudget') }} на 1 гектар для T{{treatmentIdx}}: {{ formatPrice(tabGivenBudget) }} {{ currency.symbol }}</span>
            <span class="d-block text-body-2 font-weight-bold">{{ $t('actualBudget') }} на 1 гектар для T{{treatmentIdx}}: {{ formatPrice(tabRealBudget) }} {{ currency.symbol }}</span>
            <span class="d-block text-body-2" :class="savingClass">{{ savingTitle }} {{ formatPrice(Math.abs(tabBudgetDifference)) }} {{ currency.symbol }} / га {{ $t('or') }} {{ Math.abs(tabBudgetDifferenceInPercent).toFixed(2) }}&percnt;</span>
        </div>
    </v-tab-item>
</template>

<script>
import CategoryAccordion from "./CategoryAccordion";
import CalculatorDataProvider from "../../../../app-front/mixins/CalculatorDataProvider";
import numberFormat from "../../../../utils/numberFormat";

export default {
    name: "TabResult",
    components: { CategoryAccordion },
    mixins: [ CalculatorDataProvider ],
    props: ['calculationIdx', 'treatmentIdx', 'results', 'cultures', 'categories', 'attributes'],
    data() {
        return {
            tabCheckedDrugs: []
        }
    },
    computed: {
        calculationCultureData() {
            return this.calculatorFullData[this.calculationIdx].treatments[this.treatmentIdx];
        },
        currency() {
            return this.$store.getters.currencies.find(item=>item.name === this.$store.getters.appCurrency);
        },
        tabGivenBudget() {
            let res = 0;
            this.tabCheckedDrugs.forEach(item=>{
                if(item.budget !== 0) {
                    res += parseFloat(item.budget);
                }
            })
            return res;
        },
        tabRealBudget() {
            let res = 0
            this.tabCheckedDrugs.forEach(item=>{
                res += item.selectedDrugs.reduce((sum, item)=>{
                    return isNaN(item.pricePerValue) ? sum + 0 : sum + item.pricePerValue;
                }, 0)
            })
            return res;
        },
        tabBudgetDifference() {
            return this.tabGivenBudget - this.tabRealBudget;
        },
        tabBudgetDifferenceInPercent() {
            return this.tabBudgetDifference / this.tabGivenBudget * 100;
        },
        savingClass() {
            return this.tabBudgetDifference > 0 ? 'teal--text' : 'red--text';
        },
        savingTitle() {
            return this.tabBudgetDifference > 0 ? this.$t('saving') : this.$t('overprice');
        }
    },
    methods: {
        categoryName(idx) {
            const treatmentCategory = this.calculationCultureData[idx];
            if(!treatmentCategory) return false
            const categoryId = treatmentCategory.filters.category[0]
            const category = this.categories.find(item => item.id === categoryId);
            return category ? category.localName : '---'
        },
        addSomePercents(percents, drugIdx) {
            const drug = this.getDrug(this.calculationIdx, this.treatmentIdx, drugIdx)
            const newBudget = drug.budget * (1 + percents);
            this.setBudget(newBudget, this.calculationIdx, this.treatmentIdx, drugIdx)
            this.$emit('recalculate');
        },
        calculateTabResult(data, index) {
            if(data.selectedDrugs.length > 0) {
                this.$set(this.tabCheckedDrugs, index, data)
            } else {
                this.tabCheckedDrugs.splice(index, 1);
            }
        },
        formatPrice(sum) {
            return numberFormat(sum, 2, '.', ' ');
        }
    },
    watch: {
        tabCheckedDrugs(newVal) {
            this.$emit('send-to-common-result', {
                tabGivenBudget: this.tabGivenBudget,
                tabRealBudget: this.tabRealBudget,
                tabCheckedDrugs: newVal,
            })
        },
    }
}
</script>

<style scoped>

</style>
